import Immutable from 'immutable';
import request from 'superagent';

import { DOMAIN_URL } from 'constants/Jaws';

export function normalizeDomainServiceResponse(response) {
  return Immutable.fromJS(response)
    .first()
    .map(convertStringsToBools);
}

function convertStringsToBools(val) {
  if (isBoolString(val)) {
    return JSON.parse(val);
  }

  return val;
}

function isBoolString(val) {
  return typeof val === 'string' && (val === 'false' || val === 'true');
}

export function getByItemSector(itemSector) {
  return new Promise(resolve => {
    request
      .get(`${DOMAIN_URL}`)
      .query({
        itemSector,
      })
      .end((err, res) => {
        if (err) throw new Error('Instrument.getByItemSector failed: ' + err);

        resolve(normalizeDomainServiceResponse(res.body));
      });
  });
}

// The following are taken from oms-js-utils. Remove and upgrade when possible

/**
 * Gets the ITEM and SECTOR from from an ITEM_SECTOR string
 * @param {string} itemSector - The ITEM_SECTOR to format
 * @return {array} The result as an array of [item, sector]
 */
export function getItemAndSectorFromItemSector(itemSector) {
  if (itemSector == null) {
    return null;
  }

  const index = itemSector.lastIndexOf('.');

  if (index < 1) {
    return [itemSector, null];
  }

  return [itemSector.substr(0, index), itemSector.substr(index + 1)];
}

/**
 * Gets the ITEM from an ITEM_SECTOR string
 * @param {string} itemSector - The ITEM_SECTOR to format
 * @return {array} The ITEM in the ITEM_SECTOR
 */
export function getItemFromItemSector(itemSector) {
  const [item] = getItemAndSectorFromItemSector(itemSector);
  return item;
}

/**
 * Gets the SECTOR from an ITEM_SECTOR string
 * @param {string} itemSector - The ITEM_SECTOR to format
 * @return {array} The SECTOR in the ITEM_SECTOR
 */
export function getSectorFromItemSector(itemSector) {
  /* eslint-disable no-unused-vars */
  const [_, sector] = getItemAndSectorFromItemSector(itemSector);
  return sector;
}
